import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
import useCollapseDashboardNav from '../../hooks/useCollapseDashboardNav';
// components
import Announcements from '../../components/announcements';
import GleapChat from '../../components/gleap-chat/GleapChat';
import { useSettingsContext } from '../../components/settings';
import { DASHBOARD_ANNOUNCEMENTS } from '../../consts/announcements';
import { FinancialCurrencyProvider } from '../../contexts/FinancialCurrencyContext';
import { BusinessProvider } from '../../contexts/BusinessContext';
//
import CreatePasswordPrompt from './CreatePasswordPrompt';
import Main from './Main';
import RouteTransitionGate from './RouteTransitionGate';
import Header from './header';
import BlackNovemberStrip from './header/BlackNovemberStrip';
import LevelFavicon from './LevelFavicon';
import NavHorizontal from './nav/NavHorizontal';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';

// ----------------------------------------------------------------------

function DashboardLayoutContent() {
  const { themeLayout } = useSettingsContext();

  const isDesktop = useResponsive('up', 'lg');

  // A edição do produto tem o próprio menu: o do painel recolhe ao entrar nela.
  useCollapseDashboardNav();

  const [open, setOpen] = useState(false);

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavVertical = <NavVertical openNav={open} onCloseNav={handleClose} />;

  // Chat de suporte (Gleap) so existe aqui: app logado, area do produtor.
  const renderSupportChat = <GleapChat />;

  const renderLaunchAnnouncements = <Announcements announcements={DASHBOARD_ANNOUNCEMENTS} />;

  // A campanha mora aqui, e não no `Main`, porque o `Main` também serve o
  // `StudentLayout`, e a área do aluno não tem a faixa no header.
  const renderCampaignBlock = <BlackNovemberStrip placement="content" />;

  if (isNavHorizontal) {
    return (
      <FinancialCurrencyProvider>
        {renderSupportChat}
        <LevelFavicon />
        {renderLaunchAnnouncements}

        <Header onOpenNav={handleOpen} />

        {isDesktop ? <NavHorizontal /> : renderNavVertical}

        <Main>
          {renderCampaignBlock}

          <RouteTransitionGate>
            <Outlet />
          </RouteTransitionGate>
        </Main>
      </FinancialCurrencyProvider>
    );
  }

  if (isNavMini) {
    return (
      <FinancialCurrencyProvider>
        {renderSupportChat}
        <LevelFavicon />
        {renderLaunchAnnouncements}

        <Header onOpenNav={handleOpen} />

        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}

          <Main>
            {renderCampaignBlock}

            <RouteTransitionGate>
              <Outlet />
            </RouteTransitionGate>
          </Main>
        </Box>
      </FinancialCurrencyProvider>
    );
  }

  return (
    <FinancialCurrencyProvider>
      {renderSupportChat}
      <LevelFavicon />
      {renderLaunchAnnouncements}

      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main>
          {renderCampaignBlock}

          <RouteTransitionGate>
            <Outlet />
          </RouteTransitionGate>
        </Main>
      </Box>
    </FinancialCurrencyProvider>
  );
}

export default function DashboardLayout() {
  return (
    <BusinessProvider>
      <DashboardLayoutContent />
      <CreatePasswordPrompt />
    </BusinessProvider>
  );
}
